/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import SensingSystemArchitectureDesignAppIcon from '@mui/icons-material/Architecture';
import {formRequestUrl} from './helpers';
import {Pages, Requests} from './types';
import {config} from '../../../AppConfig/config';


/** Application */
const APP_TITLE = 'Sensing System Architecture Design'
const APP_ICON = <SensingSystemArchitectureDesignAppIcon style={{width: 30, height: 50, marginRight: 10}}/>

/** Page Titles */
const LANDING_TITLE = 'Sensing System Architecture Design'
const VIEW_STUDY_TITLE = 'View Study'

/** Page Routes */
const BASE_ROUTE = '/sensing-system-architecture-design'
const VIEW_STUDY_ROUTE = BASE_ROUTE + '/study'

/** Endpoints */
export const BASE_SENSING_SYSTEM_ARCHITECTURE_DESIGN_ENDPOINT = '/HttpTriggerSensingSystemArchitectureDesign'

/** Sockets */
const SENSING_ARCH_SOCKET = 'sensingSystemArchitectureDesign'

/** Text */
export const STUDY_ADAS_PROGRAM_NULL = 'Not Selected'

/** Constants */
export const SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS = {
  app: {
    title: APP_TITLE,
    icon: APP_ICON,
    getSocketName: () => SENSING_ARCH_SOCKET,
  },
  landing: {
    title: LANDING_TITLE,
    route: BASE_ROUTE,
    endpoints: {
      fetchStudies: formRequestUrl(Pages.LANDING, Requests.FETCH_STUDIES),
      newStudy: formRequestUrl(Pages.LANDING, Requests.NEW_STUDY),
      editStudy: formRequestUrl(Pages.LANDING, Requests.EDIT_STUDY),
      deleteStudy: formRequestUrl(Pages.LANDING, Requests.DELETE_STUDY),
    },
    constants: {
      tableUuids: {
        studiesTable: 'sensingSystemArchitectureDesignStudiesTable',
      },
      queryStringKeys: {},
    },
  },
  viewStudy: {
    title: VIEW_STUDY_TITLE,
    route: VIEW_STUDY_ROUTE,
    endpoints: {
      fetchExperiments: formRequestUrl(Pages.VIEW_STUDY, Requests.FETCH_EXPERIMENTS),
      editExperiment: formRequestUrl(Pages.VIEW_STUDY, Requests.EDIT_EXPERIMENT),
      importSensors: formRequestUrl(Pages.VIEW_STUDY, Requests.IMPORT_SENSORS),
      fetchPlotData: formRequestUrl(Pages.VIEW_STUDY, Requests.FETCH_PLOT_DATA),
      sensingSystemArchitectureDesignOrchestrator: `${config.url.API_URL}/orchestrators/DurableFunctionsSensingSystemArchitectureDesignOrchestrator`,
      getSensorIdToName: formRequestUrl(Pages.VIEW_STUDY, Requests.GET_SENSOR_ID_TO_NAME),
      getDatasetIdToData: formRequestUrl(Pages.VIEW_STUDY, Requests.GET_DATASET_ID_TO_DATA),
      getGreenlineIdToProperties: formRequestUrl(Pages.VIEW_STUDY, Requests.GET_GREENLINE_ID_TO_PROPERTIES),
      downloadDataSet: formRequestUrl(Pages.VIEW_STUDY, Requests.DOWNLOAD_DATA_SET),
      checkIfObjectsValidForBlueLineGeneration: formRequestUrl(Pages.VIEW_STUDY, Requests.CHECK_IF_OBJECTS_VALID_FOR_BLUE_LINE_GENERATION),
      checkIfDatasetsExist: formRequestUrl(Pages.VIEW_STUDY, Requests.CHECK_IF_DATASETS_EXIST)
    },
    constants: {
      queryStringKeys: {
        id: 'id',
      },
    },
  },
}
